import React from 'react';
import Pinned from 'assets/images/Pinned.svg';

function PinnedIcon() {
  return <img src={Pinned} style={{ height: '100%' }} alt={'Pinned Icon'} />;
}

export default PinnedIcon;
